export default {
   footer: '[[ {"a":{"href":"https://hp.euro-tronic.com/#impressum", "title":"Impressum und Datenschutz ansehen", "target":"_blank"}} ]]Impressum • Datenschutz[[ /a ]]',
   approvals: [
      'Ich stimme der Verarbeitung und Speicherung meiner Daten im Rahmen des [[ {"a":{"href":"https://hp.euro-tronic.com/#impressum", "title":"Datenschutz der euro-tronic GmbH ansehen", "target":"_blank"}} ]]Datenschutzes[[ /a ]] zu.',
      'Hiermit akzeptiere ich die Buchung zu den angegebenen Stornierungsbedingungen.'
   ]
};